import React, { useContext } from 'react';
import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { LoginContext } from '../../context/loginContext.js';
import TerminalFichada from './terminalFichada.js';

const FichadaTerminalWrapper = () => {
  const { logout } = useContext(LoginContext);

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <Button
        type="text"
        icon={<LogoutOutlined />}
        onClick={() => {
          logout();
          window.location.href = '/#/login';
        }}
        style={{
          position: 'fixed',
          top: 16,
          right: 20,
          zIndex: 100,
          color: 'rgba(255,255,255,0.45)',
          fontSize: 14,
        }}
      >
        Salir
      </Button>
      <TerminalFichada />
    </div>
  );
};

export default FichadaTerminalWrapper;
